/** Config statica vista read-only sessione campo (bug a48bb7 / redesign UX). */

export const BLOCK_TYPE_LABELS: Record<string, string> = {
  sequential: 'Sequenziale',
  parallel: 'Parallelo',
  rotation: 'Rotazione',
  break: 'Pausa',
  physical: 'Atletico',
};

/** Stato atleta nella sessione: label + colore (sempre accompagnato da testo per accessibilità). */
export const ATHLETE_STATUS_CONFIG: Record<
  string,
  { label: string; color: string; bg: string }
> = {
  available: { label: 'Disponibile', color: '#1b7a3d', bg: 'rgba(27, 122, 61, 0.10)' },
  differentiated: { label: 'Differenziato', color: '#b45309', bg: 'rgba(245, 158, 11, 0.12)' },
  injured: { label: 'Infortunato', color: '#dc2626', bg: 'rgba(239, 68, 68, 0.10)' },
  absent: { label: 'Assente', color: '#64748b', bg: 'rgba(100, 116, 139, 0.10)' },
};

export const ATHLETE_STATUS_ORDER = ['available', 'differentiated', 'injured', 'absent'];

export const LOAD_PROFILE_LABELS: Record<string, string> = {
  PHYSICAL_DOMINANT: 'Fisico dominante',
  COGNITIVE_DOMINANT: 'Cognitivo dominante',
  BALANCED: 'Bilanciato',
};
